import styled from 'styled-components';

import { Row } from '../../styles/align';
// Styles
import { colors, fontSize } from '../../styles/variables';
import { Container } from '../style';

/**
 * Formata o Container da Modal de Confirmação de envio de arquivos
 *
 * @extends {Container}
 *
 * Herda estilo para formatar o interior do Container
 * @extends {Row}
 * @extends {colors}
 */
export const StyleProcessingFile = styled(Container)`
  position: relative;
  background-color: ${colors.grey.light};
  padding: 1rem;
  text-align: center;

  .infoText {
    color: ${colors.error} !important;
  }

  ${Row} {
    display: block;
    color: ${colors.grey.darkPrimary};
    padding: 0.5rem 0.5rem;

    h2 {
      color: ${colors.secondary}
      text-align: center;
    }

    p {
      color: ${colors.black.primary};
      padding: 1rem 0;
      line-height: 1.5;
      text-align: center;
      font-size: ${fontSize.lg};

      strong {
        font-weight: 700;
        color: ${colors.black.primary};
      }
    }
  }
`;
